import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './auth/msalConfig';
import { AuthGuard } from './auth/AuthGuard';
import App from './App';
import './styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export const msalInstance = new PublicClientApplication(msalConfig);

function renderApp() {
  createRoot(document.getElementById('root')!).render(
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <AuthGuard>
          <App />
        </AuthGuard>
      </QueryClientProvider>
    </MsalProvider>,
  );
}

msalInstance
  .initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .then(() => renderApp())
  .catch((err) => {
    console.error('MSAL initialization failed, rendering anyway:', err);
    renderApp();
  });
